"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MagsParadoxAbilityHandler = exports.MagsParadoxActorAbilityFactory = exports.MagsParadoxAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const MaxAttributeIncrease_1 = require("../../core/effects/core/MaxAttributeIncrease");
const AttributeType_1 = require("../../core/enums/AttributeType");
const Registries_1 = require("../../core/state/Registries");
const Random_1 = require("../../utils/Random");
class MagsParadoxAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.MagsParadox;
        this.__typeName = "MagsParadox";
    }
}
exports.MagsParadoxAbilityArgs = MagsParadoxAbilityArgs;
let MagsParadoxActorAbilityFactory = class MagsParadoxActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("MagsParadox", "OneAllies", 2);
    }
};
MagsParadoxActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("MagsParadox")
], MagsParadoxActorAbilityFactory);
exports.MagsParadoxActorAbilityFactory = MagsParadoxActorAbilityFactory;
let MagsParadoxAbilityHandler = class MagsParadoxAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const primaryIncrease = (0, Random_1.random)(5, 10) * container.getLevel(ability.invokerId);
        const [selectedAlly] = ability.args.target.actorIds;
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.applyBuff({
                    sequence,
                    creatorId: ability.invokerId,
                    targetId: selectedAlly,
                    duration: Duration_1.Duration.Turns(3),
                    effect: new core_1.LinkedEffectsEffectArgs([
                        new MaxAttributeIncrease_1.MaxAttributeIncreaseEffectArgs(AttributeType_1.AttributeType.Power, primaryIncrease),
                        new MaxAttributeIncrease_1.MaxAttributeIncreaseEffectArgs(AttributeType_1.AttributeType.Focus, primaryIncrease),
                        new MaxAttributeIncrease_1.MaxAttributeIncreaseEffectArgs(AttributeType_1.AttributeType.Power, primaryIncrease),
                    ], false)
                });
            }
        });
    }
};
MagsParadoxAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.MagsParadox)
], MagsParadoxAbilityHandler);
exports.MagsParadoxAbilityHandler = MagsParadoxAbilityHandler;
